const SNOWFLAKE_PARTICLES_TYPE = {
  Type01: 'TYPE_01',
  Type02: 'TYPE_02',
  Type03: 'TYPE_03',
}

export { SNOWFLAKE_PARTICLES_TYPE };
